export default "__VITE_PUBLIC_ASSET__6f4c7080__"